import React, { useState } from "react";
import { Helmet } from "react-helmet";
import GenerateHomePageLinks from "../HomePageLinks/HomePageLinks";
import { MASTER_JOB_LABELS } from "../config/masterJobsApi";
import { OG_IMAGE_URL } from "../config/publicPageContent";

const latestJobsTips = [
  "Check the official notification before applying for any post.",
  "Review age limit, eligibility, fees, and important dates carefully.",
  "Keep your documents ready so you can complete applications on time.",
];

const LatestJobsPage = () => {
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="page-container">
      <Helmet>
        <title>{`Free Latest Government Jobs ${new Date().getFullYear()} | AAMSchool`}</title>
        <link rel="canonical" href="https://www.aamschool.in/latest-jobs" />
        <meta
          name="description"
          content="Browse free government job updates, recruitment notices, and application alerts on AAMSchool."
        />
        <meta property="og:title" content={`Free Latest Government Jobs ${new Date().getFullYear()} | AAMSchool`} />
        <meta
          property="og:description"
          content="Browse free government job updates, recruitment notices, and application alerts on AAMSchool."
        />
        <meta property="og:image" content={OG_IMAGE_URL} />
        <meta property="og:url" content="https://www.aamschool.in/latest-jobs" />
        <meta property="og:type" content="website" />
      </Helmet>
      <h1>Latest Government Jobs {new Date().getFullYear()}</h1>
      <p className="page-lead">
        This page collects recent government job updates for students and aspirants who want one
        place to start their search. Use it to track openings, compare opportunities, and then
        verify every detail on the official recruitment notice.
      </p>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search jobs, admit card, result..."
          className="global-search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <GenerateHomePageLinks
        label={MASTER_JOB_LABELS.latestJobs}
        header="Latest Government Jobs"
        searchTerm={searchTerm}
        showAllItems
        layoutVariant="page"
      />

      <section className="page-info-grid" aria-label="Latest jobs guidance">
        <article className="page-info-card">
          <h2>How To Use This Page</h2>
          <ul className="page-info-list">
            {latestJobsTips.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>
        <article className="page-info-card">
          <h2>Why This Section Matters</h2>
          <p>
            Recruitment pages can change quickly, so a well-organized jobs page helps users scan
            openings faster and avoid missing deadlines. This section is meant to support discovery,
            not replace the official notification.
          </p>
        </article>
      </section>
    </div>
  );
};

export default LatestJobsPage;

